import React from "react";
import Grid from "@material-ui/core/Grid";
import UsersTable from "components/UsersTable";
import { UserMultipleRoles } from "data/api";

interface ArchivedUsersProps {
  users: UserMultipleRoles[];
}

const ArchivedUsers: React.FC<ArchivedUsersProps> = ({ users }) => {
  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <UsersTable users={users} />
      </Grid>
    </Grid>
  );
};

export default ArchivedUsers;
